import { gql } from '@apollo/client';

export const DisciplineChipFragment = gql`
    fragment DisciplineChipFragment on Discipline {
        id
        name
        displayName
        code
    }
`;
